import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";
import './navbar.css';

const navLinks = [
  {
    display: "Home",
    url: "",
  },
  {
    display: "About",
    url: "About",
  },

  {
    display: "Courses",
    url: "Courses",
  },
  {
    display: "Testimonials",
    url: "Testimonials",
  },
  {
    display: "Contact",
    url: "Contact",
  },
];

const Navbar = () => {
  const menuRef = useRef();

  const menuToggle = () => menuRef.current.classList.toggle("active__menu");

  return (
    <header className="header">
      <Container>
        <div className="navigation d-flex align-items-center justify-content-between">
          <div className="logo">
            <h2 className=" d-flex align-items-center gap-1">
              <img className="Logo" width='160' height='60' alt='logo' src={'/images/logos/Vajramudita-logo-blank-white-480x190.webp'} />
            </h2>
          </div>

          <div className="nav d-flex align-items-center gap-5">
            <div className="nav__menu" ref={menuRef} onClick={menuToggle}>
              <ul className="nav__list">
                {navLinks.map((item, index) => (
                  <li key={index} className="nav__item">
                    <Link to={item.url}>{item.display}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="nav__right">
              <p className="mb-0 d-flex align-items-center gap-2">
                <i className="ri-phone-line"></i> +(44) 7986130368
              </p>
            </div>
          </div>

          <div className="mobile__menu">
            <span>
              <i className="ri-menu-line" onClick={menuToggle}></i>
            </span>
          </div>
        </div>
      </Container>
    </header>
  );
};

export default Navbar;